import script from "./QuestionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionForm.vue?vue&type=script&setup=true&lang=js"

import "./QuestionForm.vue?vue&type=style&index=0&id=0feaee16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0feaee16"]])

export default __exports__